import WeatherModal from './containers/WeatherModalContainer'

export default WeatherModal
